const animateScroll = () => {
  const query = window.matchMedia('(max-width: 992px)')

  if (query.matches) return

  const elements = document.querySelectorAll('[data-animate-scroll]')

  if (elements.length === 0) return

  const scrollAction = (entry: IntersectionObserverEntry) => {
    const rect = entry.target.getBoundingClientRect()
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const elementTop = rect.top + scrollTop
    const elementHeight = rect.height
    const windowHeight = window.innerHeight

    let scrollValue =
      (scrollTop - elementTop + windowHeight) / (windowHeight + elementHeight)
    scrollValue = Number(Math.min(Math.max(scrollValue, 0), 1).toFixed(2))
    ;(entry.target as HTMLElement).style.setProperty(
      '--scroll',
      scrollValue.toString(),
    )
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const fn = () => {
        scrollAction(entry)
      }

      if (entry.isIntersecting) {
        scrollAction(entry)
        window.addEventListener('scroll', fn, true)
        entry.target.__scrollFn = fn
      } else {
        window.removeEventListener('scroll', entry.target.__scrollFn, true)
      }
    })
  })

  elements.forEach((el) => observer.observe(el))
}

window.addEventListener('load', animateScroll)
